import React, { type ReactNode } from 'react'
import { twJoin, twMerge } from 'tailwind-merge'
import CloseIcon from 'shared/icons/close-icon'
import BaseModal, { BaseModalProps } from './base-modal'

export interface ModalProps extends BaseModalProps {
  title: string
  contentClassName?: string
  isCentered?: boolean
}

function Modal(props: React.PropsWithChildren<ModalProps>): ReactNode {
  const { children, title, ...baseModalProps } = props
  return (
    <BaseModal {...baseModalProps}>
      <div
        className={twJoin(
          'flex w-full items-start p-6 lg:p-10 lg:pb-0',
          props.isCentered ? 'justify-center' : 'justify-between',
        )}
      >
        <h3 className={props.isCentered ? 'px-6 lg:px-10' : ''}>{title}</h3>
        <button
          className={twJoin(
            'rounded-xs ring-brand-primary ring-offset-2 outline-hidden focus-visible:ring-2',
            props.isCentered && 'absolute top-6 right-6 lg:top-10 lg:right-10',
          )}
          disabled={baseModalProps.isFetching}
          onClick={baseModalProps.onClose}
        >
          <CloseIcon
            className={twJoin(
              'cursor-pointer',
              baseModalProps.isFetching && 'pointer-events-none fill-text-secondary',
            )}
          />
        </button>
      </div>
      <div
        className={twMerge(
          `rounded-lg bg-background-secondary p-6 lg:p-10`,
          props.contentClassName,
        )}
      >
        {children}
      </div>
    </BaseModal>
  )
}

export default Modal
